import { login } from "../api/auth";

export async function handleLogin(username, password) {
  if (!username || !password) {
    throw new Error("Введите логин и пароль");
  }

  const data = await login(username, password);

  if (!data.token) {
    throw new Error("Неверный логин или пароль");
  }

  localStorage.setItem("token", data.token);
  window.location.href = "/";
}